import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from 'tss-react/mui';
import useMediaQuery from '@mui/material/useMediaQuery';
import {Breakpoints as breakpoints} from 'wobi-web-common';

const useStyles = makeStyles()(theme => ({
  appRoot: {
    backgroundColor: theme.palette.background.paper,
    minHeight: '100vh',
  },
  inner: {
    '& .bottom': {
      '& .main-content': {
        padding: '34px 0 0',
      },
      [theme.breakpoints.down('lg')]: {
        // paddingLeft: 0
      },

      padding: '0px 74px 50px 74px',
    },
    '& .header': {
      background: theme.palette.mode === 'light' ?
        'transparent linear-gradient(180deg, #ECF9FE, #FBFEFF 60%, #FFFFFF52) 0% 0% no-repeat padding-box' :
        'transparent linear-gradient(180deg, #272733, #3b3b42 60%, #424242) 0% 0% no-repeat padding-box',
      padding: '50px 74px 0px 74px',
    },
    '&.mobile': {
      '& .header, & .bottom': {
        padding: 0,
      },
    },
  },

}));

const MainContainer = ({children}) => {
  const {classes} = useStyles();
  const isMobile = useMediaQuery(`(max-width:${breakpoints.mobile}px)`);

  return (
    <div className={`App ${classes.appRoot}`}>
      <div className={`${classes.inner} ${isMobile ? 'mobile' : ''}`}>
        {children}
      </div>
    </div>
  );
};

MainContainer.propTypes = {
  children: PropTypes.any,
};

export default MainContainer;
